<template>
  <span
    :class="componentClass"
    :aria-label="tooltipText"
    :data-balloon-pos="tooltipPosition"
    :style="componentStyle"
    >{{ title }}</span
  >
</template>
<script>
  export default {
    name: 'ProTag',

    props: {
      customStyle: {
        type: Object,
        default: () => {}
      },
      isRounded: {
        type: Boolean,
        default: false
      },
      position: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: 'Pro'
      },
      theme: {
        type: String,
        default: 'yellow'
      },
      tooltipText: {
        type: String,
        default: 'This is a Pro only feature!'
      },
      tooltipPosition: {
        type: String,
        default: 'up'
      }
    },

    computed: {
      componentClass() {
        return [`tag ${this.theme} ${this.position}`, { rounded: this.isRounded }]
      },

      componentStyle() {
        let style = {}

        return {
          ...style,
          ...this.customStyle
        }
      }
    }
  }
</script>
